import { render, staticRenderFns } from "./InquiryContentsMemoInfo.vue?vue&type=template&id=68a2d388&scoped=true&"
import script from "./InquiryContentsMemoInfo.vue?vue&type=script&lang=js&"
export * from "./InquiryContentsMemoInfo.vue?vue&type=script&lang=js&"
import style0 from "./InquiryContentsMemoInfo.vue?vue&type=style&index=0&id=68a2d388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a2d388",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VCol,VDivider,VRow,VSpacer})
